export default __webpack_public_path__ + "static/identify-dark-c2cd09106bff5b5779d213466a3ef8c5.png";